







import {mapGetters} from 'vuex';
import vue from 'vue';

interface ComponentData {
  timeout: number | undefined;
}

export default vue.extend({
  name: 'Home',

  data: (): ComponentData => ({
    timeout: undefined,
  }),

  computed: {
    ...mapGetters([
      'profile',
    ]),
  },

  mounted() {
    this.timeout = setTimeout(() => {
      if (this.profile) {
        this.$router.push({name: 'DefaultList'});
      } else {
        this.$router.push({name: 'FirstConnection'});
      }
    }, 3500);
  },

  beforeDestroy() {
    clearTimeout(this.timeout);
  },
});
